import {
  NoDataCell,
  TableHead,
  TableRowCell,
} from '@/components/Table/components';
import { TableColumn, TableVariant } from '@/components/Table/types';
import { Fragment, ReactElement, useState } from 'react';
import { WorkflowRow } from '../WorkflowRow';
import {
  ProcessWithWorkflows,
  ProcessWorkflowTask,
  WorkflowWithTasks,
} from '../../types';
import { t } from 'i18next';

interface ProcessRowrops {
  process: ProcessWithWorkflows;
  processColumns: TableColumn<ProcessWithWorkflows>[];
  workflowsColumns: TableColumn<WorkflowWithTasks>[];
  taskColumns: TableColumn<ProcessWorkflowTask>[];
  variant?: TableVariant;
  noOutline?: boolean;
  selected?: boolean;
  showDots?: boolean;
  depth?: number;
  noChildDots?: boolean;
  onRowHoverStyling?: string;
  collapseClassname?: string;
}

export const ProcessRow = ({
  process,
  processColumns,
  workflowsColumns,
  taskColumns,
  depth = 0,
  variant = 'medium',
  noOutline,
  onRowHoverStyling,
  collapseClassname,
}: ProcessRowrops): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <TableRowCell
        row={process}
        cols={processColumns}
        depth={depth}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        noOutline={noOutline}
        onRowClick={() => setIsOpen(!isOpen)}
        variant={variant}
        onRowHoverStyling={onRowHoverStyling}
        isTree
        onlyCollapse
        collapseClassname={collapseClassname}
      />
      {isOpen && (
        <Fragment key={`${process.id}-fragment`}>
          <tr key={`${process.id}-header-line`}>
            <td>
              <div className="relative">
                <div className="absolute left-[40px] h-[45px] border-2 text-brightGray"></div>
              </div>
            </td>
          </tr>
          <TableHead
            columns={workflowsColumns}
            variant="medium"
            isTree
            depth={depth + 1}
          />
          {process?.rows.length === 0 ? (
            <NoDataCell
              colSpan={workflowsColumns.length}
              variant={'medium'}
              noResultsLabel={t('no_workflows_available')}
            />
          ) : (
            process?.rows?.map((workflow, index) => (
              <Fragment key={`${workflow.id}-fragment`}>
                <tr key={`${workflow.id}-data-line`}>
                  <td>
                    <div className="relative">
                      <div
                        style={{
                          height: `${index == process?.rows?.length - 1 ? 49 : 53}px`,
                        }}
                        className="absolute left-[40px] h-[49px] border-2 text-brightGray"
                      ></div>
                    </div>
                  </td>
                </tr>
                <WorkflowRow
                  key={workflow.id}
                  workflow={workflow}
                  workflowsColumns={workflowsColumns}
                  taskColumns={taskColumns}
                  variant={variant}
                  isTree
                  onRowHoverStyling={onRowHoverStyling}
                  noOutline={noOutline}
                  collapseClassname={collapseClassname}
                />
              </Fragment>
            ))
          )}
        </Fragment>
      )}
    </>
  );
};
